<style lang="stylus">
    .mini-box
        position absolute
        width 208px
        padding 24px
        background #FFFFFF
        box-shadow $box-shadow
        border-radius 6px
        z-index 10
        .mini-img
            width 160px
            height 160px
            margin-bottom 24px
        .mini-text
            margin 0 auto
            width  130px
            text-align center
            color rgba(34, 34, 34, 1)
            font-size 12px
</style>

<template>
    <div
        class="mini-box"
        ref="miniBox"
        v-show="showMiniprogram"
        :style="`left: ${miniprogramLeft + leftOffset}px; top: ${miniprogramTop + topOffset}px`"
    >
        <img class="mini-img" src="@/home/assets/img/miniprogram/miniprogram.jpg" alt="" />
        <p class="mini-text">{{ $t("text") }}</p>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class MiniProgram extends Vue {
        width = 0;
        height = 0;

        get showMiniprogram() {
            return this.$store.state.showMiniprogram;
        }
        get miniprogramLeft() {
            return this.$store.state.miniprogramLeft;
        }
        get miniprogramTop() {
            return this.$store.state.miniprogramTop;
        }
        get miniprogramDirection() {
            return this.$store.state.miniprogramDirection;
        }
        get leftOffset() {
            return this.miniprogramDirection & 2 ? -this.width - 10 : 0;
        }
        get topOffset() {
            return this.miniprogramDirection & 1 ? -this.height - 10 : 0;
        }
        mounted() {
            let target = getComputedStyle(this.$refs.miniBox as HTMLElement);
            this.width = (target.width as any).replace(/[^\d]/g, "") - 0;
            this.height = (target.height as any).replace(/[^\d]/g, "") - 0;
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "text": "微信扫码打开小程序，随时随地查看个人文件"
  },
  "en": {
    "text": "Scan the QR code on WeChat to open the mini program to personal files anytime, anywhere"
  },
  "id": {
    "text": "Pindai kode QR di WeChat untuk membuka program mini dan melihat file pribadi kapan saja dan di mana saja"
  }
}
</i18n>
